import React, { useState, useEffect } from 'react';
import TrackCard from './TrackCard.js';
import PathCard from './PathCard.js';
import './TrackList.css'

function ContainerList() {
    const [tracks, setTracks] = useState([])    
    const [filteredTracks, setFilteredTracks] = useState([])
    
    const [paths, setPaths] = useState([])    
    const [filteredPaths, setFilteredPaths] = useState([])
    
    const [searchQuery, setSearchQuery] = useState('')

    const handleQueryChange = (e) => {
        setSearchQuery(e.target.value)
    }

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setFilteredTracks(searchQuery === '' ? tracks : tracks.filter((track) => { 
            return track.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                track.slug.toLowerCase().includes(searchQuery.toLowerCase()) ||
                track.shortDescription.toLowerCase().includes(searchQuery.toLowerCase())
        }))
        setFilteredPaths(searchQuery === '' ? paths : paths.filter((path) => { 

            return path.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
                path.slug.toLowerCase().includes(searchQuery.toLowerCase()) ||
                path.shortDescription.toLowerCase().includes(searchQuery.toLowerCase()) ||
                // search tracks within path
                path.tracks.some(track => track.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
                path.tracks.some(track => track.slug.toLowerCase().includes(searchQuery.toLowerCase())) ||
                path.tracks.some(track => track.shortDescription.toLowerCase().includes(searchQuery.toLowerCase())) ||
                // search modules within path
                path.tracks.some(track => track.contentModules.some(contentModule => contentModule.title.toLowerCase().includes(searchQuery.toLowerCase()))) ||
                path.tracks.some(track => track.contentModules.some(contentModule => contentModule.slug.toLowerCase().includes(searchQuery.toLowerCase()))) ||
                path.tracks.some(track => track.contentModules.some(contentModule => contentModule.shortDescription.toLowerCase().includes(searchQuery.toLowerCase())))
                
        }))
    }

    useEffect(() => {        
        getPaths().then(paths => {
            setPaths(paths)
            setFilteredPaths(paths)
        })
        // eslint-disable-next-line
    }, [])

    useEffect(() => {        
        getTracksAndModules().then(tracks => {
            setTracks(tracks)
            setFilteredTracks(tracks)
        })
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <form onSubmit={handleFormSubmit} className = 'search-form'>
                <input type="text" placeholder="Search for content" value={searchQuery} onChange={handleQueryChange}/>
                <button type="submit">Search</button>
            </form>
            <div className='track-container'>
                {filteredTracks.map(track => <TrackCard key={track.id} track = {track} isCourse={true}/>)}
                {filteredPaths.map(path => <PathCard key={path.id} path={path} tracks={path.tracks}/>)}
            </div>
        </div>
    )
}

async function getTracksAndModules() {
    const axios = require('axios');
    const url = "/.netlify/functions/cs_get_tracks"
    const response = await axios.get(url)
    return response.data.data
}

async function getPaths() {
    const axios = require('axios');
    const url = "/.netlify/functions/cs_get_paths"
    const response = await axios.get(url)
    return response.data.data
}


export default ContainerList;
